import { CircularProgress } from "@mui/material"

export const CircularLoader = ({ size = 40 }) => {
  return (
    <CircularProgress size={size}
      style={{ color: "#CB082F" }} />
  )
}
